import { render } from "./PublicToolDemoShell.vue?vue&type=template&id=4ef574f3"
import script from "./PublicToolDemoShell.vue?vue&type=script&lang=js"
export * from "./PublicToolDemoShell.vue?vue&type=script&lang=js"

import "./PublicToolDemoShell.vue?vue&type=style&index=0&id=4ef574f3&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__